// extracted by mini-css-extract-plugin
export default {"subgrupo":"Opcoes_subgrupo__n9PfL","subgrupos":"Opcoes_subgrupos__57gyO","box":"Opcoes_box__7MNhe"};